const nl = {
  general: {
    position: 'Positie',
    updateSuccess: 'Update successful!',
    editProfileImg: 'Profielafbeelding',
    editCoverImg: 'Omslagfoto',
    register: 'Inschrijven',
    login: 'Aanmelden',
    date: 'datum',
    export: 'exporteren',
    or: 'of',
    end: 'Einde',
    confirmEmail: 'Bevestig Email',
    password: 'Wachtwoord',
    forgetPassword: 'Uw wachtwoord vergeten?',
    changePassword: 'Wachtwoord wijzigen',
    confirmPassword: 'Bevestig wachtwoord',
    knownAs: 'Bekend als',
    oldPassword: 'Oud wachtwoord',
    newPassword: 'Nieuw wachtwoord ',
    minLength: 'Minimale lengte is {n}',
    unmatched: 'De {col} komt niet overeen.',
    chooseAnotherAccount: 'Log in met een ander account',
    confirmNewPassword: 'Bevestig nieuw wachtwoord',
    country: 'land',
    new: 'NIEUW',
    username: 'Gebruikersnaam',
    category: 'Categorie',
    required: 'Verplicht veld.'
  },
  editPhoto: 'Bewerk foto',
  deletePhoto: 'Verwijder foto',
  changePhoto: 'Verander foto',
  savePhoto: 'Foto opslaan',
  livetour: 'Showroom',
  country: {
    JP: 'Japan',
    KR: 'Korea',
    HK: 'Hong Kong en Macau',
    SG: 'Singapore',
    MY: 'Maleisië',
    TH: 'Thailand',
    VN: 'Vietnam',
    ID: 'Indonesië',
    PH: 'Filippijnen',
    EU: 'Europa',
    NA: 'Noord Amerika',
    NZ: 'Nieuw-Zeeland en Australië',
    TW: 'Taiwan'
  },
  vrlounge: {
    lounge: 'VR Lounge',
    networking: 'Netwerken',
    profile: 'Mijn Profiel',
    peopleOnline: 'Bezoerkers online',
    totalVisitors: 'Totaal bezoekers',
    connect: 'aansluiten',
    waitConfirmed: 'Wacht op bevestiging',
    isConfirmed: 'bevestigd',
    confirm: 'bevestigen',
    reject: 'afwijzen',
    confirmReject: 'Bent u zeker dat u wilt weigeren?',
    hintReject: 'Dit kan niet worden geannuleerd',
    thinkTwice: 'Laat me twee keer nadenken',
    rejectInvitation: 'Uitnodiging afwijzen',
    connectSuccess: 'Succesvol verbonden!',
    block: 'Blok',
    visitor: 'Bezoeker',
    exhibitor: 'Exposant',
    invitationTitle: 'Gepersonaliseerde uitnodigingsbericht',
    invitationPlaceholder: 'Hallo! Hoop met je in contact te komen! (maximaal 1000 tekens)',
    noTicketRecord: 'Geen ticketrecord. Koop een kaartje',
    invalidTicket: 'Ongeldig ticket',
    enterTicket: 'Voer uw ticker-nummer in',
    sent: 'Verzonden',
    received: 'Ontvangen',
    connected: 'Verbonden',
    agreeToContinue: 'U moet akkoord gaan met de voorwaarden en het privacybeleid om door te gaan.',
    ticketUsed: 'Dit ticket is gebruikt.',
    passwordRule: 'Het wachtwoord moet 8 tekens bevatten, minimaal één letter en één cijfer.',
    cardExchange: 'De bezoeker wil visitekaartjes met u uitwisselen, bevestig a.u.b. of u de uitwisseling wilt accepteren of weigeren.',
    loginToAccount: 'Log in op uw account',
    keepLogin: 'Ik wil ingelogd blijven',
    cantLogin: 'Lukt het niet om in te loggen? Klik hier',
    here: 'hier',
    ticketNotOnboardHint: 'Ga naar de virtuele tentoonstelling nadat u uw ticket op de fysieke tentoonstelling hebt gekocht.',
    cannotChangeAfterSubmit: 'Kan niet worden gewijzigd na verzending',
    hintLogin: 'Als u zich hebt geregistreerd met uw ticketnummer, klik op "Log in" om in te loggen met uw e-mail.',
    allRole: 'alle rollen',
    sortNameAtoZ: 'Naam (A→Z)',
    sortNameZtoA: 'Naam (Z→A)',
    onlineNewToOld: 'Laatste inlogtijd (laatste)',
    onlineOldToNew: 'Laatste inlogtijd (vroegste)',
    exhibitorFirst: 'Exposant eerst',
    visitorFirst: 'Bezoeker eerst',
    inviteTimeNewToOld: 'Uitnodigingstijd (laatste)',
    inviteTimeOldToNew: 'Tijd voor uitnodigen (vroegste)',
    basicInfo: 'Basis informatie',
    contact: 'Contact',
    contactInfo: 'contactgegevens',
    state: 'Staat',
    sentRequest: 'Verzend verzoek',
    haveNotConfirmed: 'je hebt nog niet bevestigd',
    message: 'Bericht',
    sendMessageTo: 'Seinen'
  },
  sort: 'Soort',
  filter: 'Filter',
  test: 'Test',
  apply: 'Toepassen',
  all: 'Alle',
  livingroom: 'Woonkamer',
  diningroom: 'Eetkamer',
  kitchen: 'Keuken',
  bedroom: 'Slaapkamer',
  study: 'Studeerkamer',
  bathroom: 'Badkamer',
  toilet: 'Toilet',
  garden: 'Tuin',
  garage: 'Garage',
  outdoors: 'Buiten',
  others: 'Andere',
  vrTooltip: 'VR-modus is alleen beschikbaar op mobiele apparaten',
  vrInstructions: 'Plaats de <strong>telefoon</strong> in een <strong>VR-headset</strong>.',
  send: 'Verzenden',
  scanQrCode: 'Scan de QR-code om de virtuele tour op uw telefoon te bekijken.',
  logOut: 'Uitloggen',
  postAsAnonymous: 'Nee bedankt, ik post anoniem.',
  loginGoogle: 'Aanmelden met Google+',
  loginFacebook: 'Aanmelden met Facebook',
  postComment: 'Reactie achterlaten',
  selectAction: 'Gelieve te kiezen',
  noBuilding: 'Sorry, deze LiveTour bestaat niet.',
  browserNoSupport: '<h3>Sorry, uw browser wordt niet ondersteund.</h3><p>Download en installeer een andere browser zoals<a href="https://www.google.com/chrome/browser/desktop">Chrome</a>,<a href="https://www.microsoft.com/en-us/download/internet-explorer-11-for-windows-7-details.aspx">IE11</a>, of<a href="https://www.mozilla.org/en-US/firefox/new/">Firefox</a>.</p>',
  webGlNoSupport: '<h3>WebGL-context krijgen mislukt. Uw browser of apparaat ondersteunt WebGL mogelijk niet.</h3>',
  urlNoSupportIFrameError: 'Deze link is verlopen of de pagina aanvaardt geen externe ingebedde links.',
  noPanoramas: 'Oei! Deze panorama bestaat niet.',
  buildingNotFound: '<h3>Oei! De link bestaat niet. </h3><p> De LiveTour kan niet worden gevonden.</p><a href="https://www.istaging.com/en/livetour-gallery">Zie andere LiveTours</a>',
  buildingNotInPropertyRedirect: '<h3>Oei! De LiveTour is verwijderd.</h3><p>U wordt doorgestuurd naar de eerste LiveTour van de lijst ... ... </p>.',
  information: 'Informatie',
  panoSelect: 'Panorama\'s',
  floorplan: 'Plattegrond',
  qrCode: 'QR-code',
  music: 'Muziek',
  openMusic: 'Zet achtergrondmuziek aan',
  closeMusic: 'zet achtergrondmuziek uit',
  gyro: 'Gyro',
  vrmode: 'VR-modus',
  fullscreen: 'Volledig scherm',
  like: 'Like',
  comment: 'Opmerking',
  propertyInfo: 'Groep info',
  buildingInfo: 'LiveTour info',
  buyNow: 'Koop nu',
  viewAtHome: 'Bekijken in AR',
  learnMore: 'Meer weten',
  contactSupplier: 'Contact leverancier',
  memo: 'Memo',
  location: 'Locatie',
  promotionText: 'Creëer uw LiveTour makkelijk en snel',
  promotionLinkText: 'istaging.com',
  close: 'Sluiten',
  addComment: 'Reactie toevoegen',
  share: 'Delen',
  leaveInfoContinue: 'Voer uw gegevens in om deze LiveTour te bekijken',
  company: 'Bedrijf',
  companyName: 'Bedrijfsnaam',
  name: 'Naam',
  firstName: 'Voornaam',
  lastName: 'Achternaam',
  email: 'Email',
  phone: 'Telefoon',
  occupation: 'Beroep',
  emailFormatInvalid: 'Ongeldig e-mailformaat.',
  duplicateEmail: 'Dubbele e-mail',
  privacyPolicy: 'Privacybeleid',
  userTerms: 'Voorwaarden',
  visitorLogin: 'Heeft u een account?',
  visitorAgreement1: 'Uw privacy is belangrijk voor ons. Door uw informatie in te voeren, gaat u akkoord met {company}\'s {privacyTag} en {termsTag}.',
  visitorAgreement2: 'U geeft {company} toestemming om u te bellen, e-mailen, sms-en of mailen met informatie over {company}\'s producten en diensten. U kunt deze toestemming intrekken door contact met ons op te nemen via {email}.',
  visitorAgreement: 'Ik ga akkoord met de <a href="https://www.istaging.com/legal/terms_of_service" target="_blank">Gebruiksvoorwaarden </a> en het <a href="https://www.istaging.com/legal/privacy_policy" target="_blank">Privacy Policy</a>.',
  visitorLeaveDataReason: 'Welkom bij deze virtuele ervaring! Nadat u uw contactgegevens heeft ingediend, ontvangt u een verificatielink via e-mail, zodat u kunt beginnen.',
  visitorAgreePolicy: 'Ik ga ermee akkoord dat de eigenaar van deze virtuele ervaring contact met mij mag opnemen via e-mail of telefoon.',
  visitorCheckTheEmail: 'We zijn er bijna! <br>Bevestig uw email adres. Ga naar uw inbox en verifieer uw email door te klikken op de link die u heeft ontvangen.<br>U bent één stap verwijderd van toegang tot de virtuele ervaring!',
  visitorEnterAccessKey: 'Voer de toegangscode in die u per e-mail heeft ontvangen. Als u geen toegangscode heeft ontvangen, kijk dan in uw spambox.',
  accessCode: 'toegangscode',
  accessCodeError: 'toegangscodefout',
  receiveEmailVerification: 'U heeft een e-mail ontvangen met uw toegangscode.',
  verify: 'Controleren',
  back: 'Terug',
  welcomeToLiveTour: 'Welkom bij de <strong>LiveTour</strong>',
  resend: 'Opnieuw verzenden',
  invalidAccessCode: 'Toegangscode is ongeldig',
  resendCodeError: 'Opnieuw verzenden van toegangscode mislukt',
  website: 'Website',
  cardMore: 'Meer',
  clickNavigate: 'Navigeren',
  showMore: 'Toon meer',
  searchTag: 'Zoek Tag',
  somethingWrong: '<h3>oeps... .er is iets fout gegaan... . </h3><a href="https://www.istaging.com/en/contact">meld dit onbekende probleem</a>',
  GuidedTour: 'Begeleide Tour',
  ClientWelcome: 'Welkom',
  ClientFormHint: 'Door op \'Bel nu\' te klikken, ga ik akkoord met de <a href="https://www.istaging.com/legal/terms_of_service" target="_blank" class="link-yellow">Servicevoorwaarden</a>, het <a class="link-yellow" href="https://www.istaging.com/legal/privacy_policy" target="_blank">Privacybeleid</a> en kan de makelaar telefonisch contact met mij opnemen',
  ClientFormWelcomeText: 'Vul de volgende gegevens in en klik op Bel nu. <br>U wordt online begeleid door een gids. <br>Verbind uw headset en microfoon en zorg dat u een goede netwerkverbinding heeft voor een betere ervaring.',
  ClientWelcomeNamePhoneHint: 'Voer uw naam en telefoonnummer in',
  ClientWelcomeNameHint: 'Vul uw naam in',
  ClientWelcomePhoneHint: 'Voer het telefoonnummer in of het formaat is onjuist',
  ClientWelcomeLanguage: 'Taal',
  ClientWelcomeLanguageDesc: 'Selecteer de taal van de gids.',
  ClientWelcomeLanguageHint: 'Kies een taal',
  FieldRequired: '* verplicht',
  ClientFormCallNow: 'Bel nu',
  None: 'N/A',
  Agent: 'Middel',
  RememberMe: 'Onthoud mij',
  TheFieldIsRequired: '*verplicht veld',
  IncorrectFormat: 'Verkeerde indeling',
  YouMustAgreeLicense: 'U moet akkoord gaan met de bovengenoemde voorwaarden.',
  Submit: 'Indienen',
  BuildingNonPublicInfo: 'Deze LiveTour is verborgen',
  WebRTCNotSupportTitle: 'Browser biedt geen ondersteuning aan',
  WebRTCNotSupportDesc: 'Kopieer de pagina-URL en plak deze in Google Chrome / Firefox of Safari',
  WebRTCNotSupportDesciOS: 'Kopieer de pagina-URL en plak deze in Safari',
  WebRTCNotSupportDescAndroid: 'Kopieer de pagina-URL en plak deze in Chrome of Firefox',
  WebRTCNotSupportCopyButton: 'Kopiëren met één klik',
  Copied: 'Kopiëren voltooid',
  search: 'Zoeken',
  searchContent: 'Zoek inhoud',
  noResult: 'Geen resultaten gevonden',
  searchResult: 'Zoekresultaat',
  relatedResult: 'Gerelateerd resultaat',
  scaleUp: 'Vergroten',
  scaleDown: 'Krimpen',
  viewIn3D: 'Bekijk in 3D',
  unableJoinMeeting: 'Kan niet deelnemen aan bijeenkomst',
  invalidMeetingId: 'Ongeldige meeting-ID',
  unableAccessMediaDevice: 'Uw browser blokkeert de toegang tot uw camera / microfoon. Controleer de instellingen voor mediatoestemming in de browser.',
  connectingMeeting: 'U gaat een bijeenkomst houden',
  meetingNotStartedYet: 'Kan niet deelnemen aan de bijeenkomst. Het is nog niet begonnen.',
  joinedMeeting: 'Je bent in de bijeenkomst',
  joiningMeeting: 'U gaat deelnemen aan een bijeenkomst',
  repeatJoinWarning: 'Als u weer lid wordt, wordt de verbinding met de oorspronkelijk verbonden pagina verbroken.',
  meetingIsOver: 'De bijeenkomst is voorbij.',
  startAnotherMeeting: 'Ga naar de host om een nieuwe vergadering te starten',
  closeMeeting: 'Sluiten',
  joinMeeting: 'Deelnemen aan de bijeenkomst',
  leaveMeeting: 'Verlaten',
  remainTime: 'Overgebleven tijd',
  meetingIsFull: 'Je bijeenkomst is vol',
  connectionFail: 'Verbinding mislukt',
  unableConnectMeeting: 'Kan niet deelnemen aan bijeenkomst',
  joinMeetingFail: 'Deelnemen aan bijeenkomst is mislukt',
  aboutEndMeeting: 'U staat op het punt deze bijeenkomst te beëindigen',
  aboutLeaveMeeting: 'U staat op het punt deze bijeenkomst te verlaten',
  endedMeeting: 'Deze bijeenkomst is afgelopen',
  meetingRedirect: 'We verwijzen je naar de LiveTour.',
  leftMeeting: 'Je hebt deze bijeenkomst verlaten',
  waitMeeting: 'De host gaat tijdelijk weg en de vergadering wordt voortgezet nadat de host verbinding heeft gemaakt. Als er niet binnen 5 minuten verbinding is, wordt de vergadering beëindigd.',
  disconnectMeeting: 'Je bent losgekoppeld. Probeer binnen 5 minuten opnieuw verbinding te maken en vernieuw de pagina om terug te keren naar de vergadering.',
  copyLink: 'Kopieer link',
  copySuccess: 'Succesvol gekopieerd',
  confirm: 'OK',
  cancel: 'Annuleren',
  IMServe: 'Directe klantenservice',
  product: 'Product',
  pilot: 'Pilot',
  pilotBooking: 'boek een rondleiding',
  pilotStop: 'Stop met besturen',
  pilotTours: 'Tours',
  pilotPopularTours: 'Populaire tours',
  pilotInfluencerList: 'Gids lijst',
  pilotTourBy: 'Tour door {influencer}',
  PilotDescription: 'Beschrijving',
  PilotDetailedInformation: 'Gedetailleerde informatie',
  pilotSwitchTourNotice: 'Pelaat nyt peliä "{pilot1}".<br>Haluatko varmasti käynnistää "{pilot2}"?',
  pilotSameTourNotice: 'Pelaat nyt peliä "{pilot1}".<br>Wil je vanaf het begin beginnen?',
  pilotPlayerPopupButtonYes: 'Ja',
  pilotRecorderStart: 'Klik om te beginnen',
  pilotRecorderStop: 'Klik om te stoppen',
  pilotRecorderUploading: 'Uploaden',
  pilotRecorderUploadFailed: 'Upload mislukt',
  pilotRecorderPopupTitleNotice: 'Mededeling',
  pilotRecorderPopupTitleComplete: 'Opname voltooid',
  pilotRecorderPopupTitleError: 'Fout',
  pilotRecorderPopupTextNotice: '• De opnametijd is beperkt tot 10 minuten. <br> • Geef het systeem eerst toegang tot de microfoon.',
  pilotRecorderPopupTextComplete: 'Uw opname is voltooid. Controleer in VR Editor.',
  pilotRecorderPopupTextRelogin: 'Log nogmaals in',
  pilotRecorderPopupTextError: 'Uw browser blokkeert de toegang tot uw microfoon. Controleer de instellingen voor mediatoestemming in de browser.',
  pilotRecorderPopupButtonOK: 'OK',
  pilotRecorderRemainTimeWarning: 'De opnametijd van 10 minuten loopt binnenkort af. Rond de opname zo snel mogelijk af.',
  pilotTooltipTitle: 'Herinnering, u kunt hier klikken om meer begeleide routes te zien.',
  pilotTooltipConfirm: 'Ik snap het! laten we beginnen',
  pilotTooltipCancel: 'Sla de rondleiding over',
  selectPilot: 'Selecteer piloot',
  pilotInfluencer: 'Pilot influencer',
  pilotChaptersTitle: 'Route hoofdstukken (kies om te luisteren)',
  pilotReadMoreBtnLabel: 'Bekijk volledige inhoud',
  pilotSelfBrowsingModeMessageTitle: 'Ga naar de modus voor zelfbrowsen',
  pilotSelfBrowsingModeMessageContent: 'U kunt op elk moment terugkeren naar de tourmodus door op de inschakelknop te klikken.',
  pilotReplay: 'Herhaal',
  pilotPrevious: 'Vorige',
  pilotNext: 'Volgende',
  pilotPause: 'Pauze',
  pilotPlay: 'Spelen',
  pilotTurnOnSelfBrowsingMode: 'Schakel de tourmodus uit',
  pilotTurnOffSelfBrowsingMode: 'Schakel de tourmodus in',
  uploadImage: 'Afbeelding uploaden',
  booking: {
    calendar: 'Kalender',
    reserve: 'Reserveren',
    dateSelectTitle: 'Kies een tijd die bij u past.',
    backToSelect: 'Kies een andere tijd',
    requiredField: 'Dit is een verplicht veld',
    timeRange: 'Tijdsbestek',
    fieldMessage: 'Bericht',
    confirm: 'Bevestig uw boeking',
    pleaseWait: 'Even geduld aub...',
    submitError: 'Er is een fout opgetreden tijdens het verzenden van het verzoek: ',
    reserveSuccess: 'Afspraak geslaagd',
    thanksUser: 'Bedankt,',
    confirmingEmail: 'U ontvangt binnenkort een melding waarin de details worden bevestigd.',
    emailEmptyHint: 'E-mail is leeg.'
  },
  favorites: {
    title: 'Favorieten',
    add: 'Toevoegen aan favorieten',
    remove: 'Verwijderen uit favorieten',
    category: {
      marker: 'Product',
      panorama: 'Showroom',
      company: 'Bedrijf',
      card: 'Visitekaartje'
    },
    table: {
      image: {
        company: 'Logo',
        marker: 'Product afbeelding',
        card: 'Avatar'
      },
      name: {
        company: 'Bedrijfsnaam',
        marker: 'Naam product',
        card: 'Naam'
      },
      description: {
        company: 'Beschrijving van het bedrijf',
        marker: 'Beschrijving van het product'
      },
      type: 'Type',
      // price: 'Price',
      note: 'Notitie',
      company: 'Bedrijf',
      occupation: 'Beroep',
      listEmpty: 'Nog niets'
    },
    note: {
      empty: 'Voer een notitie in...(Tot {n} letters)',
      saved: 'Opgeslagen!'
    },
    pdf: {
      export: 'Exporteer als PDF',
      exporting: 'Exporteren...',
      note: 'Notitie: ',
      pager: 'Pagina {page} van {total}'
    }
  },
  video360: {
    notAvailable: 'De video is niet beschikbaar in uw land.'
  },
  utils: {
    more: 'Meer tonen',
    less: 'Minder tonen'
  },
  introAssets: {
    enter: 'Begin'
  },
  whiteList: {
    login: 'Log in om te verkennen!',
    error: '* Ongeldig account of wachtwoord! Probeer het opnieuw.',
    warnTitle: 'Verificatie mislukt',
    warnContent: 'Uw gebruikersnaam komt niet voor in de geautoriseerde lijst, probeer het opnieuw of neem contact op met de beheerder.'
  },
  instantMessaging: {
    quickQA: 'Snelle Q&A',
    mediaMessage: 'Een bestand gedeeld',
    locationMessage: 'Een bestand gedeeld',
    startConversation: 'Ga in deze tentoonstellingsruimte in gesprek met de organisator!'
  },
  noSearchResult: 'Er zijn geen gegevens gevonden, wijzig de zoekvoorwaarden en zoek opnieuw',
  tourring: {
    host: 'Gastheer',
    noAnswer: 'De contactpersson is tijdelijk niet in staat om te antwoorden, gebruik a.u.b. de reservefunctie',
    noPushId: 'De contactpersoon is momenteel niet online, gebruik de reservefunctie',
    busy: 'De contactpersoon is al in een rondleiding, gebruik de reservefunctie',
    response: 'Zie de reserveringskalender.',
    goToReserve: 'Toegang tot de kalender',
    dialing: 'Aan het bellen',
    dialingHint: 'Na verbinding leidt dit naar een nieuw tabblad',
    handupPhoneHint: 'Uw oproep is nog niet verbonden,',
    handupPhoneHint2: 'Bevestig a.u.b. of u wilt ophangen?'
  },
  productUnavailable: 'Dit artikel is niet langer beschikbaar',
  otherFunctions: 'andere functies',
  returnToFirstPanorama: 'Keer terug naar het eerste panorama',
  cookieBannerContent: 'We use cookies to enhance your browsing experience, serve personalized ads or content. By forwarding of viewing the website, you consent to our use of cookies. Please check',
  cookieBannerContentLinkAfter: 'for detail.',
  cookieBannerPolicyLinkText: 'iStaging Privacy Statement',
  cookieBannerButtonText: 'Accept'
}

export default nl
